/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ContinueAction/Content",
  onSubmit,
  isDisabled
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
let manualActionExecutionsValueData = fromData.useDataValue({ viewPath,
context: 'manual_action_executions',
})
let aggregateData = fromHelpers.isLast(selectedValueData, manualActionExecutionsValueData)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="selected"
 onClick={selectedSubmitData}
 disabled={isDisabled}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={aggregateData ? "Submit" : "Continue"}
 data="selected"
 data="manual_action_executions"
 aggregate="helpers.js isLast"
/>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}